export default function uqnSplit(u) {
    const stringArray = u.toString().split("");
    let numberArray;
    numberArray = [];
    stringArray.forEach(e => {
        numberArray.push(Number(e));
    });
    return numberArray;
}
